import { resetState } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actionCreators';
import { EPaymentTypeIds } from '~/src/features/payments-abn/store/actionCreators';
import { updatePaymentTypeId } from '~/src/features/payments-abn/store/actions';
import { TAppThunkDispatch } from '~/src/store';

const updateClientInfo = () => {
    return (dispatch: TAppThunkDispatch): void => {
        dispatch(updatePaymentTypeId(EPaymentTypeIds.DEFAULT));
        dispatch(resetState());
    };
};

export default updateClientInfo;
